import axios from 'axios';

export default {
  getAllSlots(alias, body) {
    return axios.get(`/scheduler/static/${alias}`, body);
  },
};